import { render } from "./AIClientContent.vue?vue&type=template&id=dadc698e&scoped=true"
import script from "./AIClientContent.vue?vue&type=script&lang=js"
export * from "./AIClientContent.vue?vue&type=script&lang=js"

import "./AIClientContent.vue?vue&type=style&index=0&id=dadc698e&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dadc698e"]])

export default __exports__